import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import AGB from "@/pages/AGB";
import Widerruf from "@/pages/Widerruf";
import Danke from "@/pages/Danke";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/widerrufsrecht" element={<Widerruf />} />
          <Route path="/danke" element={<Danke />} />
          <Route path="/anfrage-erhalten" element={<Danke />} />
        </Routes>
        <Toaster
          theme="light"
          position="top-center"
          toastOptions={{
            style: {
              background: "#ffffff",
              border: "1px solid rgba(30,31,37,0.12)",
              color: "#2b2620",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
